import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getTranslation } from 'helpers/getTranslation';

import { Typography } from 'components/shared/Typography';

import { type AnalyticsStudentSessionDetailDto } from '../../TimelineSection.helpers';
import { buildSessionStory } from '../../journeySessionStory';

import styles from './SessionStory.module.scss';

/**
 * «Коротко о сессии»: where the student went and what they got done, in 1–2
 * template sentences; how it ended is the verdict right below.
 */
const SessionStory = ({
  detail,
  studentEmail,
}: {
  detail: AnalyticsStudentSessionDetailDto;
  studentEmail?: string | null;
}) => {
  const { i18n } = useTranslation();
  const sentences = useMemo(
    () => buildSessionStory(detail, { studentEmail }),
    [detail, studentEmail, i18n.language],
  );

  if (sentences.length === 0) {
    return null;
  }

  return (
    <section className={styles.story}>
      <Typography
        className={styles.title}
        variant="body3"
        weight="medium"
        mode="compact"
      >
        {getTranslation('student_page.journey.story.title')}
      </Typography>
      <Typography className={styles.text} variant="body2">
        {sentences.join(' ')}
      </Typography>
    </section>
  );
};

export default React.memo(SessionStory) as any;
